import axios from "axios";

export default function updateLoyaltyPoint({
  uuid,
  point,
  product_uuids,
  instant_win_uuids,
}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/campaignV2/customer/loyaltyPoint/update`, {
        point,
        product_uuids,
        instant_win_uuids,
        uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
